import { FC, useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './LandscapeTextBlockEditPage.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import {
  fetchBlocks,
  fetchRichTextBlockById,
  updateRichTextBlock,
} from '../../../store/landscapeAPI/block/reducers/block.slice';
import Spinner from '../../atoms/Spinner/Spinner';
import { RichTextBlockResponseDto } from '../../../store/landscapeAPI/block/dto/response/rich-text-block-response.dto';
import { LandscapeTextBlockEditTemplate } from '../../templates';
import { RichTextBlockUpdateRequestDto } from '../../../store/landscapeAPI/block/dto/request/rich-text-block-update-request.dto';
import { LocalesLanguagesConstants } from '../../../locales/locales';

interface LandscapeTextBlockEditPageProps {}

const LandscapeTextBlockEditPage: FC<LandscapeTextBlockEditPageProps> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id, storyId, blockId } = useParams();
  const navigate = useNavigate();
  const [textBlock, setTextBlock] = useState<RichTextBlockResponseDto>();

  const { richTextBlockStatus: status } = useSelector(
    (state: RootState) => state.blockSlice
  );

  useEffect(() => {
    if (blockId) {
      dispatch(fetchRichTextBlockById(blockId))
        .unwrap()
        .then((resp) => setTextBlock(resp));
    }
  }, [dispatch, blockId]);

  const handleOnChange = (textBlock: RichTextBlockResponseDto) => {
    setTextBlock(textBlock);
  };

  const callbackFn = async (textBlock: RichTextBlockResponseDto) => {
    const textBlockToUpdate: RichTextBlockUpdateRequestDto = {
      content: textBlock.content,
      blockType: textBlock.blockType,
      compactId: textBlock.compactId,
      id: textBlock.id,
      published: textBlock.published,
    };
    await dispatch(
      updateRichTextBlock({
        data: textBlockToUpdate,
        language: LocalesLanguagesConstants.en,
      })
    );
    dispatch(
      fetchBlocks({
        id: storyId!,
        type: 'compactstory',
        language: LocalesLanguagesConstants.en,
      })
    );
    navigate(
      `/landscapes/edit/${id}/updates/story/edit/${storyId}/content-blocks`
    );
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {textBlock && (
        <div className={cn(styles.wrapper)}>
          <LandscapeTextBlockEditTemplate
            handleOnChange={handleOnChange}
            textBlock={textBlock}
            callbackFn={callbackFn}
          />
        </div>
      )}
    </>
  );
};

export default LandscapeTextBlockEditPage;
